import { render } from "./WhyWait.vue?vue&type=template&id=2b989bc2&scoped=true"
import script from "./WhyWait.vue?vue&type=script&lang=js"
export * from "./WhyWait.vue?vue&type=script&lang=js"

import "./WhyWait.vue?vue&type=style&index=0&id=2b989bc2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b989bc2"]])

export default __exports__